import { GATEWAY_CONFIG } from '../config/config';
import logger from './logger';

/**
 * Service d'analytics pour tracker les événements liés à l'iframe Younzee.
 * Les endpoints gateway sont à créer — les fonctions échouent silencieusement
 * pour ne pas bloquer le flux utilisateur.
 */

// TODO: ajouter les endpoints dans GATEWAY_CONFIG.ENDPOINTS quand créés
const ANALYTICS_ENDPOINT = '/api/analytics/event';

const sendEvent = async (eventType, customerDomain, productId, customerId) => {
  try {
    const url = `${GATEWAY_CONFIG.BASE_URL}${ANALYTICS_ENDPOINT}`;
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        customer_domain: customerDomain,
        legacy_product_id: productId,
        customer_id: customerId,
      }),
    });
    logger.log(`📊 Analytics [${eventType}] envoyé — domain: ${customerDomain}, product: ${productId}, customer: ${customerId}`);
  } catch (error) {
    // Silencieux : l'analytics ne doit jamais bloquer l'expérience utilisateur
    logger.warn(`⚠️ Analytics [${eventType}] échoué (silencieux):`, error);
  }
};

/**
 * Déclenché quand la page produit charge l'iframe (bouton visible, pas forcément cliqué).
 * Correspond à une "impression" du widget Younzee.
 * customerId : UUID anonyme (généré/récupéré depuis localStorage).
 */
export const trackPageView = (customerDomain, productId, customerId) => {
  return sendEvent('page_view', customerDomain, productId, customerId);
};

/**
 * Déclenché quand l'utilisateur clique sur le bouton et ouvre l'iframe.
 * customerId : Firebase UID si connecté, sinon UUID anonyme.
 */
export const trackIframeOpen = (customerDomain, productId, customerId) => {
  return sendEvent('iframe_opened', customerDomain, productId, customerId);
};
